// AdminPage.js
import React, { useEffect, useState } from 'react';
import { apiFetch } from '../api/api'; // adjust path if different

export default function AdminPage() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const out = await apiFetch('/users/admin');  // GET with auth + X-Org-Id
        setData(out);
      } catch (e) {
        setErr(e.message || String(e));
      }
    })();
  }, []);

  if (err) return <div>{err}</div>;
  if (!data) return <div>Loading…</div>;
  return <pre>{JSON.stringify(data, null, 2)}</pre>;
}
